import { CommitmentAutoRating } from "../../../datafusion/src/CommitmentAutoRating";
import { LaneHistoryTable } from "../LaneHistoryTable";
import { RateIndexDataSummary } from "../RateIndexDataSummary";
import { Button, CityState, DataSource, HorizontalSpacer, Layout, Panel, Tab, Tabset, Textbox } from "@mcleod/components";

export abstract class AutogenLayoutSuggestedPricing extends Layout {
    buttonSearch: Button;
    citystateStopOriginCityId: CityState;
    horizontalspacer2: HorizontalSpacer;
    layoutCommitmentAutoRating: CommitmentAutoRating;
    layoutLaneHistory: LaneHistoryTable;
    layoutRateIndex: RateIndexDataSummary;
    panelFilterComponents: Panel;
    panelSearchFilter: Panel;
    sourceLaneHistory: DataSource;
    sourceRateIndexControl: DataSource;
    tabCommitmentAutoRating: Tab;
    tabLaneHistory: Tab;
    tabRateIndex: Tab;
    tabsetSuggestedPricing: Tabset;
    textboxDateRange: Textbox;
    textboxDestinationState: Textbox;
    textboxMovementStatus: Textbox;
    textboxRadius: Textbox;
}
